import * as React from 'react';
import { useState } from 'react';
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { GridHelpers, IGridDefinition, IGridCell, IGridColumnCell, IGridDetailCell } from "../helpers/GridHelpers";
import { GridDetailCard } from "./GridDetailCard";
import { GridColumn } from "./GridColumn";
import { GridHeaderColumn } from "./GridHeaderColumn";
import { GridColumnDetails } from "./GridColumnDetails";

export interface IGridGroupProps {
  formFieldDefinition: any;
  data: any[];
  groupByColumnName: string;
  groupByColumnValue: string; 
}

export const GridGroup = (props: IGridGroupProps) => {

  const [activeRow, setActiveRow] = useState("");

  var shouldRenderHeaders: boolean = true;
  const onCloseAllDetailCards = () => {
    setActiveRow("");
  };

  return (
    <div key={props.formFieldDefinition.name + "_formfield-grid"} 
      className="mijn-fnv-grid__grid-group"
    >
      {props.data !== undefined ? (
        <React.Fragment key={"gridgroup-" + props.groupByColumnName}>
          <Accordion           
            activeKey={activeRow.toString()}
            onSelect={(data) => {
              setActiveRow(data);
            }
          }>
            {props.data.map((item, index) => {
              let rowIndex = index.toString();

              let rows: any = [];
              if (shouldRenderHeaders) {
                shouldRenderHeaders = false;
                rows.push(<div key={"headerrow-" + rowIndex} 
                  className="row no-gutters mijn-fnv-grid__row">
                  {
                    GridHelpers.getHeaders( props.formFieldDefinition as IGridDefinition).map((cell : IGridCell , index) => {
                      return <GridHeaderColumn 
                        key={"grid-headerrow-cell-" + index}
                        title={cell.title}
                        cssClasses={cell.cssClasses}
                        visible={cell.visible}
                      ></GridHeaderColumn>;
                      })
                  }
                </div>);
              }

              if (GridHelpers.isRowPartOfGroup(item, props.groupByColumnName, props.groupByColumnValue)) {
              
                let contentRow: any = GridHelpers.getColumns(item, props.formFieldDefinition as IGridDefinition).map((cell : IGridColumnCell , index) => {
                  return <GridColumn
                    key={"grid-column-cell-" + rowIndex + "-" + index} 
                    data={cell.data} 
                    visible={cell.visible} 
                    cssClasses={cell.cssClasses}
                    addValueAsCssClass={cell.addValueAsCssClass}
                    dataType={cell.dataType || ""}
                    currencyFormat={cell.currencyFormat || ""}
                    decimalSeparator={cell.decimalSeparator || ""}
                    isLink={(cell as any).isLink || false}
                    url={(cell as any).url || ""}
                    valuesObject={item}
                    format={(cell as any).format || ""}
                    icon={(cell as any).icon || ""} 
                    ></GridColumn>;
                });
                rows.push(
                  <div key={"row-accordion-" + rowIndex} 
                    className={"row no-gutters mijn-fnv-grid__row-data mijn-fnv-grid__row " + (activeRow == rowIndex ? "mijn-fnv-grid__row-data--active" : "")}>
                    {contentRow}
                    {
                      ((props.formFieldDefinition as IGridDefinition).fieldContaningDetailsList === undefined ||
                       (props.formFieldDefinition as IGridDefinition).fieldContaningDetailsList === "") &&
                      (props.formFieldDefinition as IGridDefinition).gridDetailsColumns.length > 0 ?
                    <>
                      <GridDetailCard rowIndex={rowIndex}
                        activeRow={activeRow}
                        detailsLabel="Details"
                        onCloseAllDetailCards={onCloseAllDetailCards}
                      ></GridDetailCard>

                      <Accordion.Collapse eventKey={index.toString()} className={"mijn-fnv-grid__card-collapse " }>
                          <Card.Body className="mijn-fnv-grid__card-body">
                          {
                            GridHelpers.getDetailsForRow(item, props.formFieldDefinition as IGridDefinition).map((cell : IGridDetailCell , index) => {
                              return <GridColumnDetails
                                key={"grid-column-cell-" + rowIndex + "-" + index}
                                data={cell.data}
                                title={cell.title}
                                url={cell.url}
                                dataType={cell.dataType || ""}
                                currencyFormat={cell.currencyFormat || ""}
                                decimalSeparator={cell.decimalSeparator || ""}
                              ></GridColumnDetails>;
                            })
                          }
                          </Card.Body>
                        </Accordion.Collapse>
                      </> : (((props.formFieldDefinition as IGridDefinition).fieldContaningDetailsList !== undefined ||
                       (props.formFieldDefinition as IGridDefinition).fieldContaningDetailsList !== "") &&
                      (props.formFieldDefinition as IGridDefinition).gridDetailsColumns.length > 0 ? 
                      
                      <>
                      <GridDetailCard rowIndex={rowIndex}
                        activeRow={activeRow}
                        detailsLabel="Details"
                        onCloseAllDetailCards={onCloseAllDetailCards}
                      ></GridDetailCard>

                      <Accordion.Collapse eventKey={index.toString()} className={"mijn-fnv-grid__card-collapse " }>
                          <Card.Body className="mijn-fnv-grid__card-body">
                          {
                            item[(props.formFieldDefinition as IGridDefinition).fieldContaningDetailsList].map((detailItem, index) => {

                                return <div key={"detailItem" + index} className="mijn-fnv-grid__card-details-container">
                                  {GridHelpers.getDetailsForRow(detailItem, props.formFieldDefinition as IGridDefinition).map((cell : IGridDetailCell, index) => {
                                                                  
                                      return <GridColumnDetails
                                        key={"grid-column-cell-" + rowIndex + "-" + index}
                                        data={cell.data}
                                        title={cell.title}
                                        url={cell.url}
                                        dataType={cell.dataType || ""}
                                        currencyFormat={cell.currencyFormat || ""}
                                        decimalSeparator={cell.decimalSeparator || ""}
                                      ></GridColumnDetails>;
                                    
                                  })}
                                </div>;

                              }
                            )
                          }
                          </Card.Body>
                        </Accordion.Collapse>
                      </>
                      : null )
                    }
                  </div>
                );
              }

              return <React.Fragment key={"grid-row-fragment-" + index}>{rows}</React.Fragment>;
            })}
          </Accordion>
        </React.Fragment>
      ) : null}
    </div>
  );
};
